import React from "react";
import { Link } from "react-router-dom";

const Nft = ({
  tokenOneImageName,
  tokenTwoImageName,
  tokenOneLiquidityAmount,
  tokenTwoLiquidityAmount,
  formatBalanceForPrice,
  liquidityMinPrice,
  liquidityMaxPrice,
  tokenOneName,
  tokenTwoName,
  currentFee,
  id,
}) => {
  return (
    <Link
      to={`/nft-details/${id}`}
      className="w-full block px-6 cursor-pointer md:px-8 py-4 md:py-6 border-b border-lightGrayBlue dark:border-darkSlateBlue last:border-b-0 "
    >
      <div className="flex justify-between items-center mb-3">
        <div className="flex gap-3 md:gap-6 items-center">
          <div className="flex">
            <img
              src={tokenOneImageName}
              alt="USDT"
              className="w-5 h-5 md:w-10 md:h-10"
            />
            <img
              src={tokenTwoImageName}
              alt="XBR"
              className="-ml-[10px] w-5 h-5 md:w-10 md:h-10"
            />
          </div>
          <p className="text-black dark:text-white font-semibold text-base md:text-xl leading-6">
            {`${tokenOneName} / ${tokenTwoName}`}
          </p>
          <span className="text-semiBlack text-xs text-center leading-6 bg-lightBlue dark:bg-darkButBg dark:text-semiWhite w-7 rounded-lg">
            {currentFee}%
          </span>
        </div>
        <div className="flex gap-[6px] items-center">
          {tokenOneLiquidityAmount > 0 && tokenTwoLiquidityAmount > 0 ? (
            <div className="flex items-center gap-2">
              <div className="flex items-center justify-center w-4.5 h-4.5 bg-in-range rounded-full">
                <div className="bg-mediumseagreen w-[10px] h-[10px] rounded-full" />
              </div>
              <p className="text-mediumseagreen font-semibold text-ms leading-6 md:text-base">
                In range
              </p>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <div className="flex items-center justify-center w-4.5 h-4.5 bg-in-range rounded-full">
                <div className="bg-fadedRed w-[10px] h-[10px] rounded-full" />
              </div>
              <p className="text-fadedRed">Out of Range</p>
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-center gap-1 md:gap-4">
        <div className="flex items-center gap-2 w-full md:max-w-fit">
          <p className="text-semiBlack dark:text-semiWhite text-xs md:text-sm leading-4 tracking-letterSpacingSmall">
            Min:
          </p>
          <span className="h-[1px] border-b border-lightGrayBlue dark:border-darkSlateBlue flex-1 w-full md:hidden" />
          <p className="text-sm text-black dark:text-white leading-6">
            <span className="uppercase">
              {formatBalanceForPrice(liquidityMinPrice)}
            </span>{" "}
            <span className="uppercase">{tokenOneName}</span> per{" "}
            <span className="uppercase">{tokenTwoName}</span>
          </p>
        </div>
        <div className="flex items-center gap-2 w-full md:max-w-fit">
          <p className="text-semiBlack dark:text-semiWhite text-xs md:text-sm leading-4 tracking-letterSpacingSmall">
            Max:
          </p>
          <span className="h-[1px] border-b border-lightGrayBlue dark:border-darkSlateBlue flex-1 w-full md:hidden" />
          <p className="text-xs md:text-sm text-black dark:text-white leading-6">
            <span className="uppercase">
              {formatBalanceForPrice(liquidityMaxPrice)}
            </span>{" "}
            <span className="uppercase">{tokenOneName}</span> per{" "}
            <span className="uppercase"> {tokenOneName}</span>
          </p>
        </div>
        <div />
      </div>
    </Link>
  );
};

export default Nft;
